/**
 * The group a group template creates: its title and colour, shown the way a
 * monday group header looks so the author sees what will land on the board.
 */
import React from 'react';
import DynamicTextField from '../DynamicTextField';
import { GROUP_COLORS } from '../../lib/groupContent';

const TITLE_INPUT_ID = 'spt-group-title';

export default function GroupHeaderCard({ title, color, titleError, titleInputRef, onTitleChange, onColorChange }) {
  return (
    <div className="mb-6 bg-surface border border-subtle rounded-lg shadow-sm" data-tour="group">
      <div className="p-6 space-y-4">
        <div className="max-w-md">
          <label htmlFor={TITLE_INPUT_ID} className="mb-2 spt-label">
            Group title
            <span className="ml-0.5 text-danger" aria-hidden="true">
              *
            </span>
          </label>
          <DynamicTextField
            id={TITLE_INPUT_ID}
            ariaLabel="Group title"
            placeholder="e.g. Sprint kickoff tasks"
            value={title}
            onChange={onTitleChange}
            inputRef={titleInputRef}
            invalid={titleError}
          />
          {titleError && (
            <p className="mt-1 text-xs text-danger-ink" role="alert">
              This field is required
            </p>
          )}
        </div>
        <div>
          <span className="mb-2 spt-label">Group colour</span>
          <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Group colour">
            {GROUP_COLORS.map((c) => (
              <button
                key={c}
                type="button"
                role="radio"
                aria-checked={c === color}
                aria-label={c}
                title={c}
                onClick={() => onColorChange(c)}
                className="w-6 h-6 rounded-full transition-transform hover:scale-110"
                style={{
                  backgroundColor: c,
                  // selected: an outline ring around the swatch, clear of it
                  outline: c === color ? `2px solid ${c}` : 'none',
                  outlineOffset: 2,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
